import { ICON_CALENDAR } from "common/constants";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import * as moment from "moment";

const RequestItem = ({ data, index }: { data: any; index: number }) => {
  const detailsString = useMemo(() => {
    const details = [
      data?.individual?.fullName && `Individual: ${data?.individual?.fullName}`,
      data?.mda?.name && `MDA: ${data?.mda?.name}`,
      data?.amount && `Amount: ${data?.amount}`,
      data?.positionType?.name && `Position Type: ${data?.positionType?.name}`,
      data?.paymentCategory?.name &&
        `Payment Category: ${data?.paymentCategory?.name}`,
    ].filter(Boolean);

    return details.join(", ");
  }, [
    data.amount,
    data.individual,
    data.mda,
    data.positionType,
    data.paymentCategory,
  ]);

  return (
    <div className={index === 0 ? "pb-3" : "py-3"}>
      <h5 className="mb-1">
        <Link
          to={`/government-requests/${data?.id}`}
          className="text-capitalize"
        >{`${data?.mda?.name || ""}`}</Link>
      </h5>
      <p className="text-secondary mb-2">
        <span className="me-2 text-capitalize fw-semibold">
          Government Request
        </span>
      </p>
      <p className="text-muted mb-2">... {detailsString} ...</p>
      <ul className="list-inline d-flex align-items-center g-3 text-muted fs-14 mb-0">
        <li className="list-inline-item">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className={ICON_CALENDAR}></i>
            </div>
            <div className="flex-grow-1 fs-13 ms-1">
              <span className="fw-medium">
                Last updated:{" "}
                {moment(new Date(data?.updatedAt)).format("DD MMM Y")}
              </span>
            </div>
          </div>
        </li>
        {/* <li className="list-inline-item">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className={ICON_CONTRACTS}></i>
            </div>
            <div className="flex-grow-1 fs-13 ms-1">
              <span className="fw-medium">900 Contracts</span>
            </div>
          </div>
        </li> */}
      </ul>
    </div>
  );
};

export default RequestItem;
